import CartData from './CartData';
import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, Col, Container, Row } from 'reactstrap';
import { Widgets2Data2Widgets, Widgets2DataWidgets, WidgetsData1WidgetsPage } from '../../../../Data/DefaultDashboard';
import Widgets1 from '../../../Common/CommonWidgets/Widgets1';

const ProductCartConatain = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Home" title="Super Admin" mainTitle='Super Admin' />
            <Container fluid={true}>
                <Row>
				{WidgetsData1WidgetsPage.map((item, i) => (
            <Col key={i} sm='6' xl='3' lg='6' className='box-col-6'>
              <Widgets1 data={item} />
            </Col>
          ))}
                    
                </Row>
            </Container>
        </Fragment>
    );
};
export default ProductCartConatain;